// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"36e45fd4","455":"dd51174d","977":"0573d099"}[chunkId] + ".chunk.js";
};